module.exports = __webpack_public_path__ + "static/media/06.a7d29bde.mp3";